import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import TimetableDetail from './pages/TimetableDetail';
import LanguageSync from './components/LanguageSync';
import { LanguageProvider } from './context/LanguageContext';

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <LanguageSync />
        <div className="w-full md:w-[80%] lg:w-[80%] mx-auto h-[100dvh] shadow-2xl relative overflow-hidden flex flex-col bg-slate-900 text-slate-200">
          <div className="flex-1 flex flex-col overflow-hidden relative">
            <Routes>
              {/* Legacy URL redirects - must come before home route */}
              <Route path="/alimos10-en" element={<Navigate to="/timetable/line10?lang=en" replace />} />
              <Route path="/alimos10-en/*" element={<Navigate to="/timetable/line10?lang=en" replace />} />
              <Route path="/alimos10-el" element={<Navigate to="/timetable/line10?lang=el" replace />} />
              <Route path="/alimos10-el/*" element={<Navigate to="/timetable/line10?lang=el" replace />} />
              <Route path="/alimos20-en" element={<Navigate to="/timetable/line20?lang=en" replace />} />
              <Route path="/alimos20-en/*" element={<Navigate to="/timetable/line20?lang=en" replace />} />
              <Route path="/alimos20-el" element={<Navigate to="/timetable/line20?lang=el" replace />} />
              <Route path="/alimos20-el/*" element={<Navigate to="/timetable/line20?lang=el" replace />} />
              
              {/* Main routes */}
              <Route path="/timetable/:id" element={<TimetableDetail />} />
              <Route path="/" element={<Home />} />
              
              {/* Fallback */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </div>
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;